/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import HelpIcon from '@mui/icons-material/Help';
import {
  Box, Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { BTable } from 'components/BTable/BTable';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import PageTitle from 'examples/PageTitle/PageTitle';
import React, { useEffect, useState } from 'react';
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { appConstants } from "utils/appConstants";
import { blank, generateDataList, getScreenRight, showResMsg } from 'utils/generic';
import { genericMessage } from 'utils/genericMessages';
import { getClientReport, getSubcriptionPlan } from 'utils/superAdminApi';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'grid',
  justifyContent: 'center'
};

function ClientReport() {
  const [rows, setRows] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [subsciptionPlan, setSubscriptionPlan] = useState("")
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [tabledata, setTableData] = useState([]);
  const [showModel, setShowModel] = useState(false)
  const [resetClicked, setResetClicked] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const dispatch = useDispatch()
  const [customerReload, setCustomerReload] = useState(false)
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  let countryData = useSelector((state) => state.countryState.countryStateMenu.country)
  let stateData = useSelector((state) => state.countryState.countryStateMenu.state)

  const [values, setValues] = React.useState({

    emailAddress: '',
    companyName: '',
    city: '',
    state: '',
    country: '',
    stateName: "",
    countryName: "",
    zipCode: '',
    streetAddress: '',
    searchParameterList: ['clientName', 'firstname', 'lastname', 'subscriptionPlanFormatted', 'website', 'emailAddress', 'streetAddress', 'city', 'country', 'state',
      'status', 'cancellationType', 'businessLocations', 'mobileNumber', 'expiryDateString', 'cancellationEffectiveDateString',
      'activationDateString'],
    userStatus: "",
    subsciptionPlanDD: "",
    activationDuration: "",
    expiryDuration: "",
    cancelDuration: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    sortingType: "",
    sortingField: "",
  });

  const headers = [
    { label: "ClentName", key: "clientName" },
    { label: "Subsciption Plan", key: "subscriptionPlan" },
    { label: "Activation Date", key: "activationDateString" },
    { label: "Expiry Date", key: "expiryDateString" },
    { label: "Email Address", key: "emailAddress" },
    { label: "Mobile Number", key: "mobileNumber" },
    // { label: "Website", key: "website" },
    { label: "Street Address", key: "streetAddress" },
    { label: "City", key: "city" },
    { label: "Zip Code", key: "zipCode" },
    { label: "County", key: "country" },
    { label: "State", key: "state" },
    { label: "Status", key: "status" },

  ];

  useEffect(() => {
    fetchClientReport();
  }, [customerReload])

  useEffect(() => {
    (async () => {
      getRight()
      fetchSubcriptionPlan();
      setCountry(await generateDataList(countryData, "countryName", "countryName"));
      setState(await generateDataList(stateData, "stateName", "stateName"))
    })()
  }, [])
  async function getRight() {
    let right = await getScreenRight("Clients Report")
    if (right === "Full Access")
      setDisableColor(false)
    else setDisableColor(true)
  }
  const fetchClientReport = () => {
    getClientReport(values, (data) => {
      setTotalRows(data.Result_Output.clientData.totalDocs)
      setRows(data.Result_Output.clientData.docs);
      setTableData(data.Result_Output.exportData);
    }, dispatch)

  };
  let fetchSubcriptionPlan = async () => {
    getSubcriptionPlan(values, (data) => {
      setSubscriptionPlan(data.Result_Output);
    })
  };
  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };
  const FilterData = async () => {
    fetchClientReport()
  };
  const ResetData = () => {
    setValues((prevValues) => ({
      ...prevValues,
      searchParameter: "",
      userStatus: "",
      subsciptionPlanDD: "",
      activationDuration: "",
      expiryDuration: "",
      cancelDuration: "",
      stateName: "",
      countryName: "",
      page: appConstants.page,
      limit: appConstants.limit,
      sortingType: "",
      sortingField: "",
      searchParameterList: ['clientName', 'firstname', 'lastname', 'subscriptionPlanFormatted', 'website', 'emailAddress', 'streetAddress', 'city', 'country', 'state',
        'status', 'cancellationType', 'businessLocations', 'mobileNumber', 'expiryDateString', 'cancellationEffectiveDateString',
        'activationDateString'],
    }));
    setResetClicked(true);
  };
  useEffect(() => {
    if (resetClicked) {
      fetchClientReport();
      setResetClicked(false);
    }
  }, [resetClicked]);

  let SubcriptionPlanList = (subsciptionPlan).length > 0
    && (subsciptionPlan).map((item, i) => {
      return (
        <MenuItem key={i} value={item.planName}>{item.planName}</MenuItem>
      )
    }, this);

  const handlePageChange = page => {
    values.page = page;
    setCustomerReload(!customerReload)
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage
    setPerPage(newPerPage);
    setCustomerReload(!customerReload)
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
    setCustomerReload(!customerReload)
  };

  function exportSwal() {
    setShowModel(false);
    showResMsg(genericMessage.dataExportedSucces, 1000, true)
  }

  const reportCol = [
    {
      name: "Client Name",
      selector: row => row.clientName,
      sortable: true,
      sortField: 'clientName',
    },
    {
      name: "Subscription Plan",
      selector: row => row.subscriptionPlan,
      sortable: true,
      sortField: 'subscriptionPlan',
    },
    {
      name: "Activation Date",
      selector: row => row.activationDateString,
      sortable: true,
      sortField: 'activationDate',
    },
    // {
    //   name: "Activation Date",
    //   selector: row => {
    //     const activationDate = new Date(row.activationDateString);
    //     const currentDate = new Date();

    //     // Check if the date is in the future
    //     if (activationDate > currentDate) {
    //       // Handle the future date case (e.g., return a placeholder or the current date)
    //       return "Invalid date"; // Or use currentDate.toLocaleDateString() to show today's date
    //     }

    //     // Return the valid date in your desired format
    //     return activationDate.toLocaleDateString(); // Or use your custom date formatting
    //   },
    //   sortable: true,
    //   sortField: 'activationDate',
    // },

    {
      name: "Expiry Date",
      selector: row => row.expiryDateString,
      sortable: true,
      sortField: 'expiryDate',
    },
    {
      name: "Email Address",
      selector: row => row.emailAddress,
      sortable: true,
      sortField: 'emailAddress',
    },
    {
      name: "Mobile Number",
      selector: row => row.mobileNumber,
      sortable: true,
      sortField: 'mobileNumber',
    },
    {
      name: "Street Address",
      selector: row => row.streetAddress,
      sortable: true,
      sortField: 'streetAddress',
    },
    {
      name: "City",
      selector: row => row.city,
      sortable: true,
      sortField: 'city',
    },
    {
      name: "Zip Code",
      selector: row => row.zipCode,
      sortable: true,
      sortField: 'zipCode',
    },
    {
      name: "Country",
      selector: row => row.country,
      sortable: true,
      sortField: 'country',
    },
    {
      name: "State",
      selector: row => row.state,
      sortable: true,
      sortField: 'state',
    },
    {
      name: "Status",
      selector: row => row.status,
      sortable: true,
      sortField: 'status',
    },

  ]

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Clients Report" />
          <Grid container columnSpacing={2} px={2} mt={1} alignItems="center" display="flex" justifyContent="right">
            <Grid item xs={12} md={4} spacing={2} lg={1.4} >
              <MDButton
                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                color={disableColor ? "secondary" : "warning"}
                fullWidth
                onClick={disableColor ? blank : () => { setShowFilters(!showFilters) }}

              >
                {showFilters ? 'Hide Filters' : 'Set Filters'}

              </MDButton>
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.4} >
              <MDButton
                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                color={disableColor ? "secondary" : "success"}
                fullWidth
                onClick={disableColor ? blank : () => { setShowModel(true) }}
              // onClick={() => { setShowModel(true) }}
              >
                Export
              </MDButton>
            </Grid>
          </Grid>
          {showFilters && (
            <MDBox>
              <Grid item xs={12} >
                <MDBox px={1} pt={1}>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="userStatus">Status</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Status"
                            value={values.userStatus}
                            onChange={handleChange('userStatus')}

                          >
                            <MenuItem value="Active">Active </MenuItem>
                            <MenuItem value="Inactive">Inactive </MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="userStatus">Subscription Plan</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Subscription Plan"
                            value={values.subsciptionPlanDD}
                            onChange={handleChange('subsciptionPlanDD')}

                          >

                            {SubcriptionPlanList}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="userStatus">Activation Date</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Activation Date"
                            value={values.activationDuration}
                            onChange={handleChange("activationDuration")}

                          >
                            <MenuItem value="Today"> Today </MenuItem>
                            <MenuItem value="last7Days"> Last Week  </MenuItem>
                            <MenuItem value="last30Days"> Last 1 Month </MenuItem>
                            <MenuItem value="last6Months"> Last 6 Months </MenuItem>
                            <MenuItem value="last1Year"> Last 1 Year </MenuItem>
                            <MenuItem value="MoreThenYear"> More Than 1 Year </MenuItem>

                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="userStatus">Expiry Date</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Expiry Date"
                            value={values.expiryDuration}
                            onChange={handleChange("expiryDuration")}

                          >
                            <MenuItem value="Today"> Today </MenuItem>
                            <MenuItem value="next7Days">Next Week</MenuItem>
                            <MenuItem value="next30Days"> Next 1 Month </MenuItem>
                            <MenuItem value="last7Days"> Last Week </MenuItem>
                            <MenuItem value="last30Days"> Last 1 Month</MenuItem>
                            <MenuItem value="last6Months"> Last 6 Months </MenuItem>
                            <MenuItem value="last1Year"> Last 1 Year </MenuItem>
                            <MenuItem value="MoreThenYear"> More Than 1 Year </MenuItem>


                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="userStatus">Cancellation Effective Date</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Cancellation Effective Date"
                            value={values.cancelDuration}
                            onChange={handleChange("cancelDuration")}
                          >
                            <MenuItem value="Today"> Today </MenuItem>
                            <MenuItem value="next7Days">Next Week</MenuItem>
                            <MenuItem value="next30Days"> Next 1 Month </MenuItem>
                            <MenuItem value="last7Days"> Last Week </MenuItem>
                            <MenuItem value="last30Days"> Last 1 Month</MenuItem>
                            <MenuItem value="last6Months"> Last 6 Months </MenuItem>
                            <MenuItem value="last1Year"> Last 1 Year </MenuItem>
                            <MenuItem value="MoreThenYear"> More Than 1 Year </MenuItem>

                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>



                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="userStatus">Country</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Country"
                            value={values.countryName}
                            onChange={handleChange("countryName")}

                          >
                            {country}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="userStatus">State</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="State"
                            value={values.stateName}
                            onChange={handleChange("stateName")}

                          >
                            {state}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2.3}>
                      <MDBox><TextField
                        type="text"
                        label="Search"
                        variant="outlined"
                        fullWidth
                        placeholder="Search..."
                        size="medium"
                        value={values.searchParameter}
                        onChange={handleChange("searchParameter")}
                      />                     </MDBox>

                    </Grid>


                    <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                      <Link to={"/ClientReport"}>
                        <MDButton
                          className="btn-block center-container-btn btn-warning btn-back rightSpace"
                          color="warning"
                          fullWidth
                          onClick={ResetData}
                        >
                          Reset
                        </MDButton>
                      </Link>
                    </Grid>
                    <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                      <MDButton
                        rel="noreferrer"
                        variant="gradient"
                        color="success"
                        fullWidth
                        onClick={FilterData}
                      >
                        Apply
                      </MDButton>
                    </Grid>


                  </Grid>
                </MDBox>
              </Grid>
            </MDBox>
          )}
          <CardContent>
            <BTable

              columns={reportCol}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}

            />
          </CardContent>
        </Card>

        {showModel &&

          <Modal
            open={showModel}
            onClose={() => setShowModel(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Card sx={style}>
              <Box>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
                  <HelpIcon style={{ color: "red" }} />
                </Typography>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
                  Would you like to export this record?
                </Typography>
                <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                  <>
                    <MDButton color="warning" onClick={() => { setShowModel(false) }} sx={{ width: "64px", textTransform: "capitalize" }}>
                      No
                    </MDButton>
                  </>
                  &nbsp; &nbsp;
                  <>
                    <CSVLink data={tabledata} headers={headers} filename={"Clients Report (" + (new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })) + ") .csv"}>
                      <MDButton color="error" onClick={() => { exportSwal() }} sx={{ width: "64px", textTransform: "capitalize" }}>
                        Yes
                      </MDButton>

                    </CSVLink>
                  </>
                </Grid>
              </Box>
            </Card>
          </Modal>
        }
      </div>
    </DashboardLayout>
  );
}
export default ClientReport;
